import React, { useState } from "react";
import { useGetProductReviewsQuery } from "../../slices/productSlice";
import Review from "./Review";

const TABS = ["Description", "Reviews"];

const ProductDescriptionAndReviews = ({ product }) => {
  const [activeTab, setActiveTab] = useState(TABS[0]);
  const {
    data: reviews,
    isLoading,
    isError,
  } = useGetProductReviewsQuery(product?.id);

  return (
    <div className="flex flex-col mx-auto md:mx-4 md:mt-0 w-full">
      {/* Tabs */}
      <div className="flex border-b border-agGrayLight mb-4">
        {TABS.map((tab) => (
          <button
            key={tab}
            className={`px-4 py-2 text-sm font-nunito ${
              activeTab === tab
                ? "text-agBlack font-semibold border-b-2 border-agPrimary"
                : "text-agLightGray hover:text-agBlack"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="p-4 bg-white rounded-xl shadow-md">
        {activeTab === "Description" ? (
          <div className="text-agBlack">
            <div
              className="text-sm text-agLightGray font-light leading-loose"
              dangerouslySetInnerHTML={{
                __html: product?.description || "No description available.",
              }}
            ></div>
          </div>
        ) : (
          <div>
            {isLoading ? (
              <p className="text-sm text-agLightGray">Loading reviews...</p>
            ) : isError ? (
              <p className="text-sm text-agRed">Failed to load reviews.</p>
            ) : (
              <div>
                {/* Pass reviews to the Review Component */}
                <Review
                  productId={product?.id}
                  reviews={reviews}
                  existingReview={reviews?.find(
                    (review) => review.customer === product.customerId,
                  )}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductDescriptionAndReviews;
